import { c as _c } from "react/compiler-runtime";
interface DropForgeMediaTypePillProps {
  label: string;
  className?: string;
}
export default function DropForgeMediaTypePill(t0) {
  const $ = _c(3);
  const {
    label,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `tw-inline-flex tw-w-fit tw-rounded-full tw-border tw-border-iron-700 tw-bg-iron-900 tw-px-3 tw-py-1 tw-text-sm tw-font-medium tw-uppercase tw-tracking-wider tw-text-white ${className}`;
  let t3;
  if ($[0] !== label || $[1] !== t2) {
    t3 = <span className={t2}>{label}</span>;
    $[0] = label;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}